import React, { useMemo } from 'react';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { BaseText } from '@components';
import { useTutorialsModel } from '@models/Tutorials/TutorialsModel';
import { useTagsModel } from '@models/Tags/TagsModel';

const HeaderText = styled(BaseText)({
  fontWeight: 'semi',
  color: '$heading800',
  variant: 'text.xxlarge',
});

export const TutorialListHeader = observer(() => {
  const { t } = useTranslation();
  const tutorials = useTutorialsModel();
  const tags = useTagsModel();

  const title = useMemo(() => {
    let text = t('hub.all');

    if (tutorials.categories.appliedFilterNames) {
      const filterNames = tutorials.categories.appliedFilterNames
        .slice(0, 2)
        .join(', ');

      if (tutorials.categories.appliedFilterNames.length > 2) {
        text = t('hub.moreFilters', {
          filterNames,
          moreNumber:
            tutorials.categories.appliedFilterNames.length - 2,
        });
      } else {
        text = filterNames;
      }
    } else if (tags.recommended.appliedTagNames) {
      const tagNamesArr = tags.recommended.appliedTagNames.map(
        (tagName) => t('hub.tagName', { tagName }),
      );
      const tagNames = tagNamesArr.slice(0, 2).join(', ');

      if (tags.recommended.appliedTagNames.length > 2) {
        text = t('hub.moreTags', {
          tagNames,
          moreNumber: tags.recommended.appliedTagNames.length - 2,
        });
      } else {
        text = tagNames;
      }
    }

    return text;
  }, [
    tutorials.categories.appliedFilterNames,
    tags.recommended.appliedTagNames,
  ]);

  return <HeaderText>{title}</HeaderText>;
});
